import { render, staticRenderFns } from "./GestioneAttivitaProgettiListComponent.vue?vue&type=template&id=8bcf6b86"
import script from "./GestioneAttivitaProgettiListComponent.vue?vue&type=script&lang=js"
export * from "./GestioneAttivitaProgettiListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports